// Single source for the Case Detail backend-enum mirrors. Each set lists the
// values the FE knows how to localize; `translateEnum` renders a known value
// via its locale key and falls back to the raw string for anything else (so a
// new backend enum surfaces readably instead of leaking a missing-i18n key).
//
// Consolidated here (was duplicated module-scope across OverviewTab and
// RecentActivitiesTable) so the recognized-value lists live in one place —
// pre-computed once at import, not re-created per render. The delivery-method
// set moved with components/OrderSummaryStrip when it was promoted, and the
// resolution-type set moved with components/RecentActivitiesTable (its only
// consumer) when that panel was promoted for the Reports order-rating detail.
// The escalation-type/status sets were removed with the Overview tab's
// redundant Escalation pane (AI-912) — they had no other consumer.

// Timeline event labels emitted by the backend.
export const KNOWN_TIMELINE_LABELS: ReadonlySet<string> = new Set([
  'conversation_started',
  'escalated',
  'escalation_acknowledged',
  'escalation_resolved',
  'resolved',
])
